import { render, staticRenderFns } from "./Game1-4.vue?vue&type=template&id=2ee0016e&scoped=true&"
import script from "./Game1-4.vue?vue&type=script&lang=js&"
export * from "./Game1-4.vue?vue&type=script&lang=js&"
import style0 from "./Game1-4.vue?vue&type=style&index=0&id=2ee0016e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee0016e",
  null
  
)

export default component.exports